import Util from './util';

let baseUrl = 'http://wps.docer.wps.com/v3.php';
let _ajax = {
    get_cate: '/ajax/get_cate',

    cate_rank: '/ajax/cate_rank',

    hot_moban: '/ajax/hot_moban',

    same_moban: '/ajax/same_moban',

    lucky: '/ajax/lucky',

    get_mb: '/ajax/get_mb',

    preview: '/ajax/preview',

    my_fav: '/ajax/my_fav',

    add_fav: '/ajax/add_fav',

    del_fav: '/ajax/del_fav',

    like_hate: '/ajax/like_hate',

    my_used: '/ajax/my_used',

    dl: '/ajax/dl',

    search_list: '/ajax/search_list',

    add_order: '/ajax/add_order',

    my_order: '/ajax/my_order',
};

let _request = function(ctx, option) {
    return {
        to(method, fnName, param) {
            if (ctx.$http[method]) {

                let reqUrl = `${baseUrl}/${option.type}${_ajax[fnName]}`;
                let _conf = {
                    'method': method.toUpperCase(),
                    'headers': {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    'credentials': true
                };

                if (~['get', 'delete', 'head', 'jsonp'].indexOf(method)) {
                    reqUrl += param ? `?${param}` : '';
                    return ctx
                            .$http[method](reqUrl, _conf)
                            .then(function(res) {
                                if (res.body.result === 'error') {
                                    Util.capture('log', 'docer api response error');
                                }

                                return res;
                            })
                            .catch(function(err) {
                                Util.capture('error', 'docer api http error');
                                return err;
                            });
                }

                if (~['post', 'put', 'patch'].indexOf(method)) {
                    return ctx
                            .$http[method](reqUrl, param, _conf)
                            .then(function(res) {
                                if (res.body.result === 'error') {
                                    Util.capture('log', 'docer api response error');
                                }

                                return res;
                            })
                            .catch(function(err) {
                                Util.capture('error', 'docer api http error');
                                return err;
                            });
                }
            }

            return new Promise(function(resolve, reject) {
                reject(new Error('method is not found'));
            });
        }
    }
};

function plugin(Vue, option) {
    if (plugin.installed) {
        return;
    }

    // depends on vue-resource
    if (!Vue.resource) {
        return;
    }

    if (!option || !option.type) {
        return;
    }

    Object.defineProperties(Vue.prototype, {
        $mb_ajax: {
            get() {
                return _request(this, option);
            }
        }
    });
}

export default plugin;



// WEBPACK FOOTER //
// ./app/assets/js/mb_ajax.js